import type { SsqVersion } from "src/api/sure-api/ssq/useGetOneSsqVersion";
import type { Dimensions } from "src/context/OlapScores/useDimensions";

export const buildProductScoreDetailDimensions = (ssqVersion: SsqVersion | undefined): Dimensions => {
    const questionnaireDimensions: Dimensions = [
        [["headings"], ["subheadings"], ["properties"], ["subproperties"], ["multivalues"]],
    ];

    const compositionDimensions: Dimensions = [
        [["components", ["product"]], ...questionnaireDimensions[0]],
        [["components", ["ingredients"]], ["ingredients"]],
        [["components", ["transformations"]], ["transformations"]],
        [["components", ["packagings"]], ["packagings"]],
        [["components", ["transport"]], ["transport_lines"]],
        [["components", ["distribution"]], ["distribution"]],
        [["components", ["consumption"]], ["consumption"]],
    ];

    return ssqVersion?.ssq?.monolithic ? questionnaireDimensions : compositionDimensions;
};
